import styled from 'styled-components';
import { ITheme } from '../../styles/theme';

// Page header (title, actions, section tabs). Static — it never collapses or changes size,
// so content below it doesn't jump around while scrolling.
export const StickyHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  ${({ theme }: { theme: ITheme }) => `
    gap: ${theme.layout.spacing.decy};
    padding: ${theme.layout.spacing.deka} 56px 0 56px;
  `}
`;

interface ICreateSurveyCont {
  /** Fit the page exactly into the viewport (Contents tab): only the inner content list scrolls. */
  $lockViewport?: boolean;
}

export const CreateSurveyCont = styled.div<ICreateSurveyCont>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  ${({ $lockViewport }: ICreateSurveyCont) =>
    $lockViewport
      ? `
    height: 100vh;
    overflow: hidden;
  `
      : ''}
`;

export const MenuMock = styled.div`
  height: 100%;
  width: 427px;
  margin: 0 16px 0 56px;
  background: grey;
`;

export const CreateSurveyBody = styled.div``;
